import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropdown w-full" }
const _hoisted_2 = {
  tabindex: "-1",
  class: "btn"
}
const _hoisted_3 = {
  tabindex: "-1",
  class: "dropdown-content z-[1] menu shadow bg-base-100 rounded-box"
}
const _hoisted_4 = ["onClick"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDown',
  props: {
    entries: {},
    title: {},
    selectedValue: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const valueToShow = computed(() =>
  props.selectedValue == null ? props.title : props.selectedValue
);

const emit = __emit;

const emitSelect = (item: string): void => {
  emit("select", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(valueToShow.value), 1),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.entries, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("button", {
            class: "p-2",
            onClick: () => emitSelect(item)
          }, [
            _createElementVNode("li", null, _toDisplayString(item), 1)
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}
}

})